module.exports = __webpack_public_path__ + "static/media/metuchen.0f6d2b30.png";